<template>
  <section class="p-2">
    <v-card>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="ma-0">
            <v-col cols="12" md="4" lg="3">
              <v-autocomplete
                v-model="selectedCountry"
                class="rounded"
                dense
                outlined
                hide-details
                item-text="txt"
                item-value="val"
                :items="senderCountrys"
                @input="getPartners(selectedCountry)"
                placeholder="Sender Country"
              ></v-autocomplete>
            </v-col>
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-1 text-decoration-none"
              color="primary"
              @click="getResults(selectedCountry)"
              >Get Results</v-btn
            >
          </v-row>
        </v-card>
      </v-card-text>
      <v-data-table
        fixed-header
        height="55vh"
        :headers="dessertHeaders"
        :items="RatesSummary"
        :search="search"
        dense
        item-key="name"
      >
        <template v-slot:item.exchange_markup="{ item }">
          <div class="d-flex">
            {{ item.exchange_markup }}
            <div v-if="item.markup_type == 'Flat'"></div>
            <div v-else>%</div>
          </div>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="d-flex">
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="editItem(item)"
            >
              mdi-content-save-edit-outline
            </v-icon>
            <v-icon
              small
              title="Edit"
              color="primary"
              class="mr-2"
              @click="deleteItem(item)"
            >
              mdi-trash-can-outline
            </v-icon>
          </div>
        </template>

        <template v-slot:top>
          <div class="d-flex">
            <v-btn
              depressed
              small
              class="text-capitalize me-2 ms-2 mt-2 text-decoration-none"
              color="primary"
              @click="openDialog()"
              ><v-icon small>mdi-plus</v-icon>Add</v-btn
            >
            <v-spacer> </v-spacer>
            <v-spacer> </v-spacer>
            <v-btn
              depressed
              @click="downloadExcelsheet"
              color="primary"
              small
              class="me-5 mt-2"
              ><v-icon small>mdi-file-excel-outline</v-icon>Export
            </v-btn>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Type here to filter the table data."
              hide-details
              class="me-4 mb-2"
              dense
              clearable
            ></v-text-field>
          </div>
        </template>
      </v-data-table>
      <v-dialog persistent v-model="showDialog" width="800">
        <v-card>
          <v-form ref="Addform" v-model="valid">
            <v-toolbar color="#050048" dark flat dense>
              <span>{{ formtitle }} Rates Setup</span>
              <v-spacer></v-spacer>
              <v-btn depressed icon @click="closeDialog()">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="6"
                  ><label class="my-0 labelFontsize required">
                    Channel Partner
                  </label>
                  <v-autocomplete
                    v-model="RatesDetails.send_partner"
                    class="rounded"
                    dense
                    outlined
                    :disabled="RatesDetails.id"
                    :items="senderPartners"
                    item-text="txt"
                    item-value="val"
                    :rules="FieldRequired('Send Partner')"
                    placeholder="Partner"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6"
                  ><label class="my-0 labelFontsize required">
                    Payout Country
                  </label>
                  <v-autocomplete
                    v-model="RatesDetails.payout_country"
                    class="rounded"
                    dense
                    outlined
                    :disabled="RatesDetails.id"
                    placeholder="Country"
                    item-text="txt"
                    item-value="val"
                    :items="countryOptions"
                    :rules="FieldRequired('Payout Country')"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="6"
                  ><label class="my-0 labelFontsize required">
                    Round Settlement Ex.Rate
                  </label>
                  <v-text-field
                    dense
                    outlined
                    placeholder="Settlement Exchange Rate"
                    class="rounded"
                    type="number"
                    hide-spin-buttons
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Settlement Exchange Rate')"
                    v-model="RatesDetails.round_settle_ex_rate"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <label class="my-0 labelFontsize required">
                    Round Payment Amount
                  </label>
                  <v-text-field
                    class="rounded"
                    v-model="RatesDetails.round_payout_amount"
                    dense
                    outlined
                    placeholder="Min"
                    type="number"
                    hide-spin-buttons
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Payment Amount')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <label class="my-0 labelFontsize required">
                    Round Send Amount</label
                  >
                  <v-text-field
                    class="rounded"
                    v-model="RatesDetails.round_send_amount"
                    dense
                    outlined
                    placeholder="Max"
                    type="number"
                    hide-spin-buttons
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Send Amount')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6">
                  <label class="my-0 labelFontsize required"
                    >Threshold Customer Rate Change
                    <span class="caption">(default-10%)</span></label
                  >
                  <v-text-field
                    class="rounded"
                    v-model="RatesDetails.threshold_customer_rate"
                    dense
                    outlined
                    placeholder=""
                    type="number"
                    hide-spin-buttons
                    @keydown="filterNumberInput"
                    :rules="FieldNumbRequired('Customer Rate Change')"
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="6" class="d-flex">
                  <v-col cols="5 px-0">
                    <label class="my-0 labelFontsize required"
                      >Exchange Markup</label
                    >
                    <v-autocomplete
                      v-model="RatesDetails.markup_type"
                      class="rounded"
                      dense
                      outlined
                      item-text="txt"
                      item-value="val"
                      :items="docs_LIST"
                      placeholder="Markup Type"
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="7 px-0">
                    <label class="my-0 labelFontsize"></label>
                    <v-text-field
                      class="rounded"
                      v-model="RatesDetails.exchange_markup"
                      dense
                      outlined
                      placeholder=""
                      type="number"
                      hide-spin-buttons
                      @keydown="filterNumberInput"
                      :rules="FieldNumbRequired('Exchange Markup')"
                    >
                    </v-text-field>
                  </v-col>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="pa-0 mb-0"></v-divider>
            <v-card-actions class="ma-0 pt-0">
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                @click="submitData()"
                ><v-icon small>mdi-content-save-plus-outline</v-icon>Submit
              </v-btn>
              <v-btn
                depressed
                small
                class="text-capitalize me-2 ms-2 mt-5 text-decoration-none"
                color="primary"
                outlined
                @click="closeDialog()"
                ><v-icon small>mdi-close</v-icon>cancel
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="border border-bottom">Delete</v-card-title>
          <v-card-text class="h5 py-3"
            >Are you sure you want to delete ?</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteLedgerById()"
            >
              Delete<v-icon>mdi-check</v-icon>
            </v-btn>
            <v-btn
              depressed
              small
              color="primary"
              outlined
              @click="deleteDialog = false"
            >
              Close<v-icon>mdi-close</v-icon></v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <OverlayPageVue :showOverlay="loader" />
    </v-card>
  </section>
</template>

<script>
import OverlayPageVue from "@/utils/OverlayPage.vue";
import commonService from "@/services/CommonService/commonService.js";
import setupService from "@/services/SetupService/setupService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import { FieldRequired, FieldNumbRequired } from "@/utils/validation.js";
import { filterNumberInput } from "@/utils/contactNumber/formatNumber.js";
import alerts from "@/mixins/alerts";
export default {
  mixins: [alerts],
  name: "Master Bank Summary",
  data() {
    return {
      selectedCountry: "All",
      FieldRequired,
      FieldNumbRequired,
      filterNumberInput,
      search: "",
      loader: false,
      showDialog: false,
      deleteDialog: false,
      delete_id: null,
      valid: true,
      editedIndex: -1,
      countryOptions: [],
      docs_LIST: [],
      senderPartners: [],
      senderCountrys: [],
      dropdown: {
        country_objs: [],
      },
      dessertHeaders: [
        {
          text: "Id",
          sortable: false,
          value: "id",
        },
        { text: "Channel Partner", value: "send_partner", sortable: false },
        { text: "Sending Country", value: "country", sortable: false },
        { text: "Payout Country", value: "payout_country", sortable: false },
        {
          text: "Settlement Ex.Rate",
          value: "round_settle_ex_rate",
          sortable: false,
        },
        { text: "Payout Amt", value: "round_payout_amount", sortable: false },
        { text: "Send Amt", value: "round_send_amount", sortable: false },
        {
          text: "Customer Rate",
          value: "threshold_customer_rate",
          sortable: false,
        },
        { text: "Markup Type", value: "markup_type", sortable: false },
        { text: "Ex.Markup", value: "exchange_markup", sortable: false },
        { text: "Action", value: "action", sortable: false },
      ],
      RatesSummary: [],
      RatesDetails: {
        send_partner: "",
        payout_country: "",
        rate_level: "CW",
        round_settle_ex_rate: 0,
        round_payout_amount: 0,
        round_send_amount: 0,
        threshold_customer_rate: 0,
        exchange_markup: 0,
        markup_type: "",
        currency: "",
      },
    };
  },
  components: {
    OverlayPageVue,
  },
  watch: {},
  mounted() {
    this.getcountryList();
    this.getdocss();
    this.getAllSendCountrys();
    this.getPartners(this.selectedCountry);
    this.getResults(this.selectedCountry);
  },
  computed: {
    formtitle() {
      return this.editedIndex === -1 ? "Add" : "Edit";
    },
  },
  methods: {
    getResults(value) {
      if (value == "All") {
        this.getAllRates();
      } else {
        this.getAllRatesByCountry(value);
      }
    },
    async getAllRates() {
      this.loader = true;
      try {
        const response = await setupService.getAllFixRates("CW");
        if (response.data.status_code === 200) {
          this.RatesSummary = response.data.data[0].reverse();
          console.log("Rates Data", this.RatesSummary);
          this.stoploader();
        } else {
          this.RatesSummary == [];
          this.stoploader();
        }
      } catch (error) {
        this.RatesSummary = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getAllRatesByCountry(selectedCountry) {
      this.loader = true;
      try {
        const response = await setupService.getRatesByCountry(
          "CW",
          selectedCountry,
        );
        if (response.data.status_code === 200) {
          this.RatesSummary = response.data.data[0].reverse();
          console.log("Rates Data", this.RatesSummary);
          this.stoploader();
        } else {
          this.RatesSummary == [];
          this.stoploader();
        }
      } catch (error) {
        this.RatesSummary = [];
        this.stoploader();
        console.error(error);
      }
    },
    async getAllSendCountrys() {
      try {
        const responseData = await partnerService.getAllSenderCountrys();
        if (responseData.data.status_code === 200) {
          this.senderCountrys = responseData.data.data.map((i) => {
            return { txt: i.name, val: i.iso3 };
          });
          this.senderCountrys.unshift("All");
        }
        console.log("Send Countrys", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getById(id) {
      this.loader = true;
      try {
        const response = await setupService.getRatesById(id);
        if (response.data.status_code === 200) {
          this.RatesDetails = response.data.data[0];
          console.log("Rate Data", this.RatesSummary);
          this.stoploader();
        } else {
          this.RatesDetails = {};
          this.stoploader();
        }
      } catch (error) {
        this.RatesDetails = {};
        this.stoploader();
        console.error(error);
      }
    },
    submitData() {
      const validate = this.$refs.Addform.validate();
      if (validate) {
        if (this.RatesDetails.id) {
          this.update();
        } else {
          this.save();
        }
      }
    },
    async save() {
      try {
        const response = await setupService.addFixedRate(this.RatesDetails);
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.showDialog = false;
          this.getAllRates();
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    async update() {
      try {
        const response = await setupService.updateFixedRate(
          this.RatesDetails.id,
          this.RatesDetails,
        );
        if (response.data.status_code === 200) {
          this.showAlertSuccess(response.data.message);
          this.showDialog = false;
          this.getAllRates();
        } else {
          this.showAlertError(response.data.message);
        }
      } catch (error) {
        console.error(error);
      }
    },
    deleteItem(item) {
      this.deleteDialog = true;
      this.delete_id = item.id;
    },
    async deleteLedgerById() {
      this.loader = true;
      try {
        const responseData = await setupService.deleteFixedRate(this.delete_id);
        console.log(`up: ${JSON.stringify(responseData)}`);

        if (responseData.data.status_code === 200) {
          this.loader = false;
          this.deleteDialog = false;
          this.getAllRates();
          this.showAlertSuccess(responseData.data.message);
        } else {
          this.loader = false;
          this.deleteDialog = false;
          this.showAlertError(responseData.data.message);
        }
        console.log("respose data", responseData);
      } catch (e) {
        this.loader = false;
        this.deleteDialog = false;
        this.showAlertError("fetch data Something went wrong");
        console.error(e);
      }
    },
    async getcountryList() {
      try {
        const response = await setupService.getCountrysetupList();
        if (response.status === 200) {
          this.countryOptions = response.data.data.map((i) => {
            return { txt: i.name, val: i.iso_alpha3 };
          });
          this.dropdown.country_objs = response.data.data;
        }
        console.log("countrys", response);
      } catch (e) {
        console.error(e);
        this.countryOptions = [];
      }
    },
    async getdocss() {
      const code = "MUT";
      try {
        const responseData = await commonService.getparameterdropdowns(code);
        if (responseData.data.status_code === 200) {
          this.docs_LIST = responseData.data.data.map((i) => {
            return { txt: i.value, val: i.value_code };
          });
        }
        console.log("docs_LIST", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    getPartners(value) {
      if (value == "All") {
        this.getAllSendPartners();
      } else {
        this.getPartnersByCountry(value);
      }
    },
    async getPartnersByCountry(country) {
      try {
        const responseData = await partnerService.getCountryPartners(country);
        if (responseData.data.status_code === 200) {
          console.log("tiktik", responseData.data);
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getAllSendPartners() {
      try {
        const responseData = await partnerService.getAllSenderPartners();
        if (responseData.data.status_code === 200) {
          console.log("tiktik", responseData.data);
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },

    stoploader() {
      setTimeout(() => {
        this.loader = false;
      }, 400);
    },

    async downloadExcelsheet() {
      if (this.RatesSummary) {
        this.exportToExcel(
          this.dessertHeaders,
          this.RatesSummary,
          "RatesSummary",
        );
      }
    },

    openDialog() {
      this.editedIndex = -1;
      this.showDialog = true;
      this.resetRatesDetailsObj();
      if (this.$refs.Addform) {
        this.$refs.Addform.resetValidation();
      }
    },
    resetRatesDetailsObj() {
      this.RatesDetails.id = null;
      this.RatesDetails.send_partner = null;
      this.RatesDetails.payout_country = "";
      this.RatesDetails.round_settle_ex_rate = 0;
      this.RatesDetails.round_payout_amount = 0;
      this.RatesDetails.round_send_amount = 0;
      this.RatesDetails.threshold_customer_rate = 0;
      this.RatesDetails.exchange_markup = 0;
      this.RatesDetails.markup_type = "F";
      this.RatesDetails.rate_level = "CW";
    },

    editItem(item) {
      this.editedIndex = 1;
      this.showDialog = true;
      this.getById(item.id);
    },

    closeDialog() {
      this.showDialog = false;
      this.$refs.Addform.resetValidation();
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/global.scss";

.width-anchor {
  width: 200px !important;
}

.required:after {
  content: " *";
  color: red;
}

.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
}
.bord-color {
  border-radius: 10px;
}
</style>
